const MAX_TIMEOUT_DELAY = 2147483647;

export default class Banner {
  constructor({ templateId, startDate, finishDate }) {
    this.templateId = templateId;
    this.template = null;
    this.elements = {
      body: null,
      navbar: null,
      banner: null
    };

    this.dates = {
      now: null,
      start: startDate ? new Date(startDate) : null,
      finish: finishDate? new Date(finishDate) : null
    };
    this.timeouts = {
      render: null,
      destroy: null
    };
    this.defaultStyles = {
      bodyPaddingTop: 0,
      navbarTop: 0
    };
    
    document.addEventListener('DOMContentLoaded', () => {
      this._init();
    });
  }

  _init() {
    this.template = document.getElementById(this.templateId);

    if (!this.template) return;

    this.dates.now = new Date();

    if (this._isLate() && this.dates.finish) return;

    this._findElements();

    if (this._isEarly() && this.dates.start) {
      this._scheduleRendering();
    } else {
      this._render();
    }

    if (this.dates.finish) {
      this._scheduleDestruction();
    }
  }

  _render() {
    if (this.timeouts.render) {
      clearTimeout(this.timeouts.render);
      this.timeouts.render = null;
    }

    this._insertBanner();
    this._shiftNavbar();
    this._listen();
  }

  _scheduleRendering() {
    const ms = this.dates.start - this.dates.now;

    if (ms < 0 || ms >= MAX_TIMEOUT_DELAY) return;

    this.timeouts.render = setTimeout(() => {
      this._render();
    }, ms);
  }

  _destroy() {
    if (this.timeouts.destroy) {
      clearTimeout(this.timeouts.destroy);
      this.timeouts.destroy = null;
    }

    this.elements.banner.remove();
    this._resetNavbarPosition();
    this._removeListeners();
  }

  _scheduleDestruction() {
    const ms = this.dates.finish - this.dates.now;

    if (ms < 0 || ms >= MAX_TIMEOUT_DELAY) return;

    this.timeouts.destroy = setTimeout(() => {
      this._destroy();
    }, ms);
  }

  _saveDefaultStyles() {
    const { body, navbar } = this.elements;

    this.defaultStyles.bodyPaddingTop = parseInt(window.getComputedStyle(body).paddingTop);
    this.defaultStyles.navbarTop = parseInt(window.getComputedStyle(navbar).top);
  }

  _insertBanner() {
    const clone = this.template.content.cloneNode(true);
    const id = `${ this.templateId }-rendered`;
    
    clone.querySelector('.js-banner').setAttribute('id', id);
    document.body.prepend(clone);

    this.elements.banner = document.getElementById(id);
  }

  _findElements() {
    this.elements.body = document.body;
    this.elements.navbar = document.querySelector('.js-navbar');
  }

  _shiftNavbar() {
    const bannerHeight = this.elements.banner.offsetHeight;
    const { body, navbar } = this.elements;

    body.style.paddingTop = `${ bannerHeight }px`;
    navbar.style.top = `${ bannerHeight }px`;
  }

  _throttledShiftNavbar = _.throttle(this._shiftNavbar, 50).bind(this);

  _resetNavbarPosition() {
    const { body, navbar } = this.elements;
    const { bodyPaddingTop, navbarTop } = this.defaultStyles;

    body.style.paddingTop = `${ bodyPaddingTop }px`;
    navbar.style.top = `${ navbarTop }px`;
  }

  _isEarly() {
    return this.dates.now < this.dates.start;
  }

  _isLate() {
    return this.dates.now > this.dates.finish;
  }

  _listen() {
    window.addEventListener('resize', this._throttledShiftNavbar);
  }

  _removeListeners() {
    window.removeEventListener('resize', this._throttledShiftNavbar);
  }

  getTimes() {
    return {
      startDate: this.dates.start,
      finishDate: this.dates.finish
    };
  }
}
